import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { URLS } from "config/urls";
import { MoreVertIcon } from "icons";
import { reverse } from "utils/urls";

import ButtonDropdown from "components/ButtonDropdown";
import { MenuItem } from "components/Menu";
import toast from "components/Toast";

import AssetManagementFilesList from "entities/AssetManagement/components/AssetManagementFilesList";
import UploadAssetsFileDialog from "entities/AssetManagement/components/UploadAssetsFileDialog";

const AssetManagementActionsButton = () => {
  const params = useParams<{ dealId: string }>();
  const dealId = Number(params.dealId);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [filesDialogOpen, setFilesDialogOpen] = useState(false);

  const navigate = useNavigate();

  const handleLoading = useCallback(() => {
    toast.successMessage(
      "You will be notified once the processing has finished."
    );
  }, []);

  return (
    <>
      <ButtonDropdown
        width="190px"
        label="Imported datasets"
        icon={<MoreVertIcon />}
        buttonDataTestid="asset-mgmt-actions-button"
      >
        <MenuItem
          onClick={() => setOpenUploadDialog(true)}
          dataTestid="upload-excel-file-option"
        >
          Upload new data
        </MenuItem>
        <MenuItem
          onClick={() => setFilesDialogOpen(true)}
          dataTestid="uploaded-excel-files-history-option"
        >
          View uploaded files
        </MenuItem>
        <MenuItem
          onClick={() =>
            navigate(
              reverse(URLS.DEAL_ASSET_MANAGEMENT_VERSIONS, {
                dealId,
              })
            )
          }
          dataTestid="version-history-option"
        >
          Version history
        </MenuItem>
      </ButtonDropdown>
      <UploadAssetsFileDialog
        open={openUploadDialog}
        handleClose={() => setOpenUploadDialog(false)}
        dealId={dealId}
        setLoading={handleLoading}
      />
      {filesDialogOpen && (
        <AssetManagementFilesList
          open={filesDialogOpen}
          onClose={() => setFilesDialogOpen(false)}
          dealId={dealId}
        />
      )}
    </>
  );
};

export default AssetManagementActionsButton;
